<template>
  <v-dialog persistent v-bind="[$attrs, $props]" width="500">
    <v-form ref="form" class="white py-8 px-7">
      <div class="primary--text form__title mb-5">
        Confirmar {{ typeModal }} de Cancelamento de Apólice
      </div>
      <div class="mb-5">
        <BaseFormTextArea
          :label-text="labelForm"
          required
          v-model="form.justificativa"
          id-element="descriptionCommunication"
          placeholder="Justificativa"
          :rules="[requiredInput, maxLengthTextArea]"
        />
      </div>
      <v-row>
        <v-spacer />
        <v-col cols="6" sm="3" class="pr-5">
          <BaseButton
            v-html="'CANCELAR'"
            color="secondary"
            outlined
            width="100%"
            @click="closeModal"
          />
        </v-col>
        <v-col cols="6" sm="3">
          <BaseButton
            v-html="'CONFIRMAR'"
            class="secondary"
            width="100%"
            @click="submit"
          />
        </v-col>
      </v-row>
    </v-form>
  </v-dialog>
</template>
<script>
import { requiredInput, maxLengthTextArea } from "@/utils/rules.js";
export default {
  data: () => ({
    form: {},
    requiredInput,
    maxLengthTextArea
  }),
  computed: {
    labelForm() {
      return `Por favor, informe o motivo para prosseguir com a ${this.typeModal.toLowerCase()} de cancelamento da Apólice ${
        this.numberPolicy
      }`;
    }
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
    submit() {
      if (this.$refs.form.validate()) this.$emit("submit", this.form);
    }
  },
  props: {
    numberPolicy: {
      type: String
    },
    typeModal: {
      type: String,
      default: "Solicitação"
    }
  }
};
</script>
